import { Banner } from '@/components/ui/Banner';
import { cn } from '@/utils/cn';

interface ErrorAlertProps {
  message: string;
  className?: string;
}

export function ErrorAlert({ message, className }: ErrorAlertProps) {
  return <Banner tone="error" className={cn('mb-s4', className)}>{message}</Banner>;
}
